import { message } from "antd";
import useRequest from "./useRequest";
import { useState } from "react";

const useBuses = () => {
  const [buses, setBuses] = useState([]);
  const [busExcursions, setBusExcursions] = useState([]);

  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
    getDailyProfit: false, // Added
    getPeriodProfit: false, // Added
  });

  const { request } = useRequest();

  async function getBusDetail(busId) {
    return await request(
      "GET",
      `scheduled-excursions-buses/${busId}/`,
      (data) => {
        return data;
      },
      (error) => {
        return error;
      },
      {}
    );
  }

  async function getBuses(params = {}) {
    return await request(
      "GET",
      "scheduled-excursions-buses/",
      (data) => {
        setBuses(data);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function deleteBus(busId) {
    return await request(
      "DELETE",
      `scheduled-excursions-buses/${busId}/`,
      (data) => {
        setBuses((prev) => {
          const newResults = prev.filter((bus) => bus.id !== busId);

          return newResults;
        });

        return data;
      },
      (error) => {
        return error;
      },
      {}
    );
  }

  async function getBusExcursion(params = {}) {
    return await request(
      "GET",
      "bus-excursions/",
      (data) => {
        setBusExcursions(data);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
  }

  async function updateBus(body) {
    setLoading((prev) => ({ ...prev, put: true }));
    const data = await request(
      "PATCH",
      `scheduled-excursions-buses/${body.id}/`,
      (data) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.success("Bus actualizado correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.error("Error al actualizar");
        return error;
      },
      body
    );
    return data;
  }

  async function createBus(body) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      "scheduled-excursions-buses/",
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Bus creado correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al crear");
        return error;
      },
      body
    );
    return data;
  }

  async function autoassignBuses(scheduleExcursionId) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      `scheduled-excursions/${scheduleExcursionId}/autoassign-buses/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Micros asignados correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error(
          error?.response?.data?.error ||
            "Error al asignar micros. Deben estar los micros creados y hoteles de salida asignados."
        );
        return error?.response?.data;
      }
    );
    return data;
  }

  async function dealocateBuses(scheduleExcursionId) {
    setLoading((prev) => ({ ...prev, post: true }));
    const data = await request(
      "POST",
      `scheduled-excursions/${scheduleExcursionId}/deallocate-buses/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Micros desasigandos correctamente");
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al desasignar micros");
        return error;
      }
    );
    return data;
  }

  async function getDailyProfitReport(date) {
    setLoading((prev) => ({ ...prev, getDailyProfit: true }));
    const data = await request(
      "GET",
      `scheduled-excursions/reports/profit/daily/`,
      (responseData) => {
        setLoading((prev) => ({ ...prev, getDailyProfit: false }));
        return responseData;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, getDailyProfit: false }));
        const errorMsg =
          error?.response?.data?.detail || "Error al obtener reporte diario";
        message.error(errorMsg);
        return { error: true, message: errorMsg };
      },
      {},
      { date }
    );
    return data;
  }

  async function getPeriodProfitReport(startDate, endDate) {
    setLoading((prev) => ({ ...prev, getPeriodProfit: true }));
    const data = await request(
      "GET",
      `scheduled-excursions/reports/profit/period/`,
      (responseData) => {
        setLoading((prev) => ({ ...prev, getPeriodProfit: false }));
        return responseData;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, getPeriodProfit: false }));
        const errorMsg =
          error?.response?.data?.detail ||
          "Error al obtener reporte por período";
        message.error(errorMsg);
        return { error: true, message: errorMsg };
      },
      {},
      { start_date: startDate, end_date: endDate }
    );
    return data;
  }

  async function optimizeBusHotelOrder(busId) {
    const data = await request(
      "POST",
      `scheduled-excursions-buses/${busId}/optimize-hotel-order/`,
      (responseData) => {
        message.success("Orden de hoteles optimizado");
        return responseData;
      },
      (error) => {
        message.error(
          error?.response?.data?.error || "Error al optimizar orden de hoteles"
        );
        return error?.response?.data;
      }
    );
    return data;
  }

  return {
    createBus,
    getBuses,
    updateBus,
    deleteBus,
    setBuses,
    buses,
    getBusExcursion,
    getBusDetail,
    setBusExcursions,
    autoassignBuses,
    dealocateBuses,
    busExcursions,
    getDailyProfitReport,
    getPeriodProfitReport,
    optimizeBusHotelOrder,
    loading,
  };
};

export default useBuses;
